import { Icon } from './Icon.jsx';

/**
 * Initials in a coloured circle. The hue comes from the name, so the same
 * person gets the same colour on every card and in the names list; the
 * lightness is decided in CSS so it suits both themes. The speaker gets the
 * accent and a person glyph instead of the letters of "You".
 */
const HUES = [172, 24, 262, 340, 205, 48, 120, 300];

function hueFor(name: string): number {
  let hash = 0;
  for (const char of name.toLowerCase()) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return HUES[hash % HUES.length] ?? 172;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return (parts[0] ?? '').slice(0, 2).toUpperCase();
  return `${parts[0]?.[0] ?? ''}${parts[1]?.[0] ?? ''}`.toUpperCase();
}

export function Avatar({ name, me = false, size = 32 }: { name: string; me?: boolean; size?: number }): React.ReactElement {
  return (
    <span
      className={`avatar${me ? ' me' : ''}`}
      style={{ ['--h' as string]: hueFor(name), width: size, height: size, fontSize: size * 0.38 }}
      aria-hidden="true"
    >
      {me ? <Icon name="user" size={size * 0.55} /> : initials(name)}
    </span>
  );
}
